import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import './index.scss';
import {
  isIE,
} from 'react-device-detect';
import ConnectedIntlProvider from 'shared/util/ConnectedIntlProvider';
import { FormattedMessage } from 'react-intl';
import { Provider } from 'react-redux';
// import * as serviceWorker from './serviceWorker';
import store from './shared/redux/store';
import App from './App';


const history = createBrowserHistory();

if (isIE) {
  ReactDOM.render(
    (<Provider store={store}>
      <ConnectedIntlProvider>
        <FormattedMessage id="ieUnsupport" />
      </ConnectedIntlProvider>
     </Provider>), document.getElementById('root'),
  );
} else {
  ReactDOM.render(
    <Router basename={process.env.PUBLIC_URL} history={history}>
      <App history={history} />
    </Router>, document.getElementById('root'),
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
